import App from '@/app.vue';
import Components from '@/components';
import { byteToKb, capitalizeFilter, currencyFilter, dateFilter, dateTimeFilter, decimalFilter, padLeft, percentageFilter, singleLineAddress, timeFilter } from '@/filters';
import router from '@/router';
import '@/scss/app.scss';
import store from '@/store';
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue';
// @ts-ignore
import Autocomplete from 'v-autocomplete';
import 'v-autocomplete/dist/v-autocomplete.css';
import VeeValidate from 'vee-validate';
import Vue from 'vue';
import VueMoment from 'vue-moment';
// @ts-ignore
import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';

Vue.config.productionTip = false;
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
Vue.use(VeeValidate, { fieldsBagName: 'validationFields' });
Vue.use(Autocomplete);
Vue.use(VueMoment);
Vue.component('multiselect', Multiselect);
Vue.use(Components);
Vue.filter('date', dateFilter);
Vue.filter('datetime', dateTimeFilter);
Vue.filter('time', timeFilter);
Vue.filter('singlelineaddress', singleLineAddress);
Vue.filter('padLeft', padLeft);
Vue.filter('byteToKb', byteToKb);
Vue.filter('percentage', percentageFilter);
Vue.filter('decimal', decimalFilter);
Vue.filter('currency', currencyFilter);
Vue.filter('capitalizeFirst', capitalizeFilter);

async function start(): Promise<void> {
    await store.dispatch('user/loadMeAsync');
    await store.dispatch('environment/loadAsync');

    const root = new Vue({
        router,
        store,
        render: (h) => h(App),
    }).$mount('#app');
}

start();
